import ServiceError from '../../domain/ServiceError.js';
import AuthenticationServiceError from '../../domain/AuthenticationServiceError.js';
import ServerError from '../../domain/ServerError.js';

class HttpResponseHandler {

  constructor(urlGenerator) {

    this.urlGenerator = urlGenerator;

  }

  extractResponseFromRequest(responseData) {

    let data = getResponseData(responseData);

    processRequestErrors.bind(this)(responseData, data);

    return data;

  }

  handleHttpError(ex) {

    throw new ServerError(500);

  }

}

let getResponseData = function (responseData) {

  if (responseBodyIsValid(responseData.body)) {
    let data = responseData.body;

    if (data.hasOwnProperty('data')) {
      data = data.data;
    }

    return data;
  }

};

let responseBodyIsValid = function (data) {

  return data !== undefined
    && data !== null
    && data !== '';

};

let processRequestErrors = function (responseData, data) {

  if (responseIdentifiedAsUnsuccessful(responseData.status)) {

    if (serverErrorFound(responseData)) {
      throw new ServerError(responseData.status, data);
    }

    if (authenticationErrorFound.bind(this)(responseData)) {
      throw new AuthenticationServiceError(responseData.status, data);
    }

    throw new ServiceError(responseData.status, data);

  }

};

let responseIdentifiedAsUnsuccessful = function (status) {

  return status < 200
    || status >= 300;

};

let serverErrorFound = function (responseData) {

  return responseData.status >= 500;

};

let authenticationErrorFound = function (responseData) {

  let url = responseData.url;

  return url !== undefined
    && url !== null
    && url.indexOf(this.urlGenerator.getAuthenticationUrl()) >= 0;

};

export default HttpResponseHandler;



// WEBPACK FOOTER //
// ./src/library/services/http/HttpResponseHandler.js